import React from 'react';
import PropTypes from 'prop-types';
import MultiSelect from './components/multiSelect';

export const options = [
  {
    id: 1,
    label: 'Actively looking',
    description: 'Ready to interview and make a change soon.',
    value: 'actively_looking',
  },
  {
    id: 2,
    label: 'Passively open to the right opportunity',
    description: 'Not actively looking but open for great opportunities.',
    value: 'casually_browsing',
  },
  {
    id: 3,
    label: 'Not looking for a change',
    description: 'I’m just curious, but not actively looking for a new opportunity.',
    value: 'not_looking',
  },
];

export const Opportunity = ({ onChange, data, variant }) => (
  <MultiSelect
    initialData={data}
    onChange={(opportunity) => onChange('opportunity', opportunity)}
    options={options}
    type="radio"
    variant={variant}
  />
);

Opportunity.propTypes = {
  onChange: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  variant: PropTypes.string,
};

Opportunity.defaultProps = {
  variant: 'onboarding',
};

export default Opportunity;
